export enum SuppliersRoutesEnum{
    SUPPLIERS_LIST        = 'suppliers-list',
    SUPPLIERS_DETAIL      = 'suppliers-detail',
    SUPPLIERS_USERS_LIST  = 'suppliers-users-list',
    SUPPLIERS_USER_DETAIL = 'suppliers-users-detail',
    SUPPLIERS_ZONES       = 'suppliers-zones',
}